import {Injectable} from '@angular/core';
import {OauthService} from './oauth.service';
import {Observable} from 'rxjs/Observable';
import {Search} from '../models/search/search.model';
import {Http} from '@angular/http';
import {App} from 'ionic-angular';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class SondageService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }

  getAll(search: Observable<Search> = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => this.searchAll(s, s.action));
  }

  searchAll(search: Search, action: string) {
    const param = {'_format': 'json'};

    for (const item in search) {
      if (search[item] !== null) {
        param[item] = search[item];
      }
    }

    const url = this.Routing.generate('api_get_sondages', param, true);
    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => ({data: response.json().data, action}));
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/sondage.service.ts